export const LOGIN_ACTION = 'LOGIN_ACTION'
export const GET_REFRESH_TOKEN = 'GET_REFRESH_TOKEN';
export const GOOGLE_SIGNUP_ACTION = 'GOOGLE_SIGNUP_ACTION'
export const LOGOUT = "LOGOUT"
export const VERIFY_OTP_ACTION = "VERIFY_OTP_ACTION"
export const CLEAN_LOGIN_DATA="CLEAN_LOGIN_DATA"